import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import ApiMakerTable from "shared/api-maker-table"
import {Challenge} from "models"
import ChallengeLink from "components/challenges/link"
import classNames from "classnames"
import linkProps from "shared/link-props"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import SurveyLink from "components/surveys/link"
/**
 * @typedef {object} ComponentsChallengesTableProps
 * @property {unknown} adminLayout
 * @property {string} className
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsChallengesTableState */

/**
 * @extends {ShapeComponent<ComponentsChallengesTableProps, ComponentsChallengesTableState>}
 */
class ComponentsChallengesTable extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {columns, editModelPath, viewModelPath} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--challenges--table", className)}
        columns={columns}
        editModelPath={editModelPath}
        modelClass={Challenge}
        preloads={["survey"]}
        select={{
          Challenge: ["id", "name"],
          Survey: ["id", "name"]
        }}
        viewModelPath={viewModelPath}
        {...restProps}
      />
    )
  }

  columns = () => [
    {
      attribute: "id",
      defaultVisible: false,
      sortKey: "id"
    },
    {
      content: this.tt.challengeContent,
      label: Challenge.humanAttributeName("name"),
      sortKey: "currentTranslationName"
    },
    {
      content: this.tt.surveyContent,
      label: Challenge.humanAttributeName("survey"),
      sortKey: "surveyCurrentTranslationName"
    },
    {
      attribute: "public",
      sortKey: "public"
    }
  ]

  editModelPath = ({challenge}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.editAdminChallengePath(challenge.id())
  }

  viewModelPath = ({challenge}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.adminChallengePath(challenge.id())
  }

  challengeContent = ({challenge}) => <ChallengeLink challenge={challenge} {...linkProps(this.props)} />
  surveyContent = ({challenge}) => challenge.survey() && <SurveyLink survey={challenge.survey()} {...linkProps(this.props)} />
}

export default memo(shapeComponent(ComponentsChallengesTable))
